export default __webpack_public_path__ + "static/media/HeroBackground.b8ddabed.jpg";